import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { initPageContextEpic } from './_epics/initPageContext.epic';

export const pageContextEpic = safeCombineEpics(
  initPageContextEpic,
);
